module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-38-d3db17d19281cbbbed92e90c1f764eab.svg";